const baseURL = "https://yambaafrica.com/api"

export default baseURL;
